// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ad-cprplus-label-pop{text-align:center;top:50%;margin-top:-260px!important}.ad-cprplus-label-pop .el-dialog__body{padding:20px;height:420px;border-top:1px solid #e9e9e9;border-bottom:1px solid #e9e9e9}.ad-cprplus-label-pop .el-dialog__footer{padding:0;text-align:center}", ""]);
// Exports
module.exports = exports;
